{
  "message": "english",
  "mytext": "Goodbye",
  "Colon": ":",
  "SeeMore": "More >",
  "Notification": "new",
  "ProfileTitle": "My Profile",
  "NextButton": "Next",
  "PrintButton": "Print",
  "PreviousButton": "Back",
  "Reset": "Reset",

  "Yes": "Yes",
  "No": "No",

  "Default Title": "Title",
  "Default Subtitle": "Subtitle",

  "And": "and",
  "Or": "or",

  "Search": "Search",
  "SearchResults": "Search Results",

  "Error": "Error",

  "Send": "Send",
  "Refresh": "Refresh",

  "Confirmation": "Warning",

  "Profile": {
    "Title": "My Profile",
    "Username": "Username",
    "Email": "Email",
    "Role": "Role",
    "Confirmed": "Confirmed",
    "CreationDate": "Creation Date"
  },

  "Status": {
    "new": "New",
    "accepted": "Accepted",
    "ready": "Ready",
    "proposed": "Proposed",
    "scheduled": "Scheduled",
    "completed": "Completed"
  },

  "Disclaimer": {
    "Title": "Disclaimer",
    "TextShort": "B. Braun Medical AG does not provide any warranty or guarantee with regard to the accuracy, completeness and up-to-dateness of the data on „pharmacists.bbraun.ch“.",
    "Text": "<p><b>Terms of Use</b> The information, indications, and data contained on the \"pharmacists.bbraun.ch\" website regarding B. Braun Medical SA's products, particularly infusion solutions and their use, are intended exclusively and solely to inform hospital pharmacists in Swiss hospitals who use these medicines in their facilities. Access to this information, indications, and data is granted to hospital pharmacists who have previously registered with their personal data for the purpose of accessing this information and who have received, after verification of the data by the operator, a password allowing them to access the contents of the website. By accessing the website, the user declares to accept the following terms of use and disclaimer. <br/><b>Disclaimer</b> B. Braun Medical SA has developed the information, indications, and data made available on the website with the necessary care, but does not guarantee that the information, indications, and data provided are always up-to-date, correct, complete, or of good quality. To the extent permitted by law, B. Braun Medical SA excludes all liability for itself and for the employees involved in case of damages of any kind, bodily or material, direct or indirect damages that may result from the access to the information or in connection with the access to the information, the use of the information made available, or the consultation of the information. The disclaimer also includes liability for the flawless operation of the website, in particular due to technical defects, and liability for damages resulting from transmission errors, technical defects, disruptions or interruptions of Internet access, illegal interventions in telecommunication installations, the introduction of viruses, copying and falsification of content, network overloads, failure to recognize forgeries, legitimacy defects, voluntary or accidental blockages of electronic access by third parties. The disclaimer also includes liability for damages suffered by the user (or client) due to non-fulfillment of contractual obligations, as well as for indirect damages and consequential damages, such as loss of profit or claims from third parties. B. Braun Medical SA reserves the right to modify at any time all or part of the information made available, in particular to adapt it to technical or legal developments, to complete it, to delete it, or to suspend its publication temporarily or permanently. <br/><b>Applicable Law/Jurisdiction</b> The entire website, terms of use, and disclaimer are exclusively governed by Swiss law. All disputes related to these conditions are subject to the jurisdiction of the competent courts of the headquarters of B. Braun Medical SA.</p>"
  },

  "Infusion": {
    "InContainer": {
      "Title": "In a container",
      "Text": "Infusion solution is tested for physico-chemical compatibility after addition of the medicinal product.",
      "MoreText": "Ringerfundin® wurde nach Zusatz folgender i.v. Arzneimittel auf physikalisch-chemische Kompatibilität über 24 Stunden bei Raumtemperatur geprüft."
    },
    "InLine": {
      "Title": "Direct injection",
      "Text": "Mixtures of infusion solution with medicinal products are tested for physico-chemical compatibility in proportion to their infusion rates.",
      "MoreText":"Mischungen der Infusionslösung X® mit folgenden i.v. Arzneimitteln wurden im Verhältnis ihrer Infusionsgeschwindigkeiten auf die physikalisch-chemische Kompatibilität direkt nach Durchmischen (4 Minuten) und nach 60 Minuten Kontaktzeit geprüft:"
    }
  },

  "Requests": {
    "TestPlan": "Test plan",
    "CreationDate": "Creation date",
    "EditedDate": "Edited date",
    "SendQuestion": "Send Question",
    "SendResponse": "Send Response",
    "FileRejectedForGivenReason": "File rejected for given reason",
    "FileNotFound": "File not found",
    "SendPrufplan": "Send Prufplan",
    "PrufplanSent": "Prufplan sent",
    "SelectPrufplan": "Select Prufplan",
    "NewDocument": "New Document",
    "InputPlaceholder": "Enter your question here",
    "RejectRequest": "Reject Request",
    "CreatePlan": "Create Plan",
    "CreatePlans": "Create Plans",
    "ChooseMeds": "Choose Medications",
    "ChooseMedsSubtitle": "Choose for which of the following drugs you wish to create a test plan (each selected drug will create an associated test)",
    "Questions": "Clarifications / Questions Ecotox",
    "AutomatedAnswer": "Automatische Antwort",
    "ClickToSeePdf": "Click to see PDF",
    "TestPlanPropositionDocument": "Test plan proposal (PDF)",
    "ProjectNumber": "Project number",
    "Revision": "Revision",
    "Revisions": "Revisions",
    "Status": "Status",
    "TestedPreparation": "Tested preparation",
    "Preparation": "Preparation",
    "DrugSolutionConcentration": "Drug solution concentration",
    "PerfusionRate": "Perfusion rate",
    "Combination": "Combination",
    "PreparationCompatibility": "Preparation compatibility",
    "CombinationEvaluation":"Combination evaluation",
    "NoRequestAtThisStep": "No request at this step",
    "OtherTabsRequests": "Other steps requests",
    "SelectedFile": "Selected file",
    "SaveDraft": "Save draft",
    "Saved": "Saved",
    "AddCompatibility": "Add compatibility",
    "SendTestReport": "Send test report",
    "UploadTestReport": "Upload test report",
    "ChooseFile": "Choose file",
    "DocumentName": "Document name",
    "DocumentSize": "Document size",
    "PublicationDate": "Publication date",
    "PublishCompatibility": "Publish compatibility",
    "ValidatePlan": "By clicking \"yes\" you confirm the compatibility publication.",
    "ThisActionCannotBeUndone": "This action cannot be undone."
  },

  "Header": {
    "FirstNavBar": {
      "HomeButton": "Home",
      "LogoutButton": "Logout",
      "ContactButton": "Contact"
    },
    "SecondNavBar": {
      "ProdukteUndTherapienButton": "PRODUCTS AND THERAPY",
      "StoriesButton": "STORIES",
      "Companies": "COMPANY",
      "SearchPlaceholder": "Search"
    }
  },
  "Footer": {
    "FooterNav": {
      "LegalNotice": "Legal Notice",
      "TermsOfUse": "Terms of Use",
      "Privacy": "Data protection",
      "GeneralTerms": "General terms and conditions"
    }
  },
  "Home": {
    "Title": "Pharmacist",
    "Subtitle": "Knowledge portal",
    "ShowButton": "Show",
    "CompatibilityData": {
      "Title": "Compatibility data",
      "Description": "The compatibilities listed here refer to physico-chemical compatibility such as pH shift, colour change, turbidity, particle size change or precipitation. The data do not provide information regarding pharmacokinetics and dynamics. The mixtures listed do not represent dosing recommendations."
    },
    "OsmolarityCalculator": {
      "Title": "Osmolarity calculator",
      "Description": "The osmolarity calculator makes it easy for you to calculate the osmolarity of a solution with additives."
    },
    "ProductInformation": {
      "Title": "Product informations",
      "Description": "B. Braun offers products and solutions for infusion."
    },
    "FAQ": {
      "Title": "FAQ",
      "Description": "Here you will find a compilation of the most important questions and answers on various topics related to infusion therapy and parenteral nutrition."
    },
    "News": {
      "Title": "News",
      "NoNews": "No news available."
    }
  },
  "Faq": {
    "Title": "FAQs",
    "Subtitle": "Storage / shelf life",
    "Help":"How can we help you?"
  },
  "Login": {
    "PresentationSection": {
      "Title": "Informations for hospital pharmacists",
      "Resume": "With the «pharmacists.bbraun.ch» website, B. Braun Medical SA provides you with a knowledge portal to which you have a private access as a hospital pharmacist."
    },
    "LoginSection": {
      "Title": "Connection",
      "P1": "The website “pharmacists.bbraun.ch” provides the following services:",
      "P2": "Current physico-chemical compatibility data for our products",
      "P3": "Osmolarity calculator for calculating the osmolarity of solutions with additives",
      "P4": "FAQ with answers to frequently asked questions about infusion therapy",
      "DataPrivacyCheckbox": "I hereby confirm that I have read the %LINK%.",
      "DataPrivacyLink": "privacy statement",
      "EmailUsername":"E-mail address/username",
      "Password":"Password",
      "RepeatPassword":"Repeat password",
      "ForgotPassword":"Forgotten password",
      "RegisterNow":"Login",
      "ToRegister":"Register",
      "ConfirmationSent":"Confirmation e-mail has been sent",
      "AlreadyRegistered":"Already registered?",
      "OldPassword":"Old password",
      "NewPassword":"New password",
      "ConfirmNewPassword":"Confirm new password",
      "ResetPassword":"Reset password"
    },
    "ErrorHandling": {
      "EmptyFields":"Please fill in all fields.",
      "InvalidCredentials":"Invalid credentials.",
      "PasswordRegexp":"Password must be at least 8 characters long and contain at least one number and one letter.",
      "PasswordMismatch":"Passwords do not match.",
      "EmailRegexp":"Invalid e-mail address.",
      "EmailAlreadyRegistered":"E-mail address is already registered.",
      "DataPrivacy": "Please accept the data privacy statement.",
      "UnknownError":"Unknown error."
    },
    "DisclaimerSection": {
      "Title": "Disclaimer",
      "DisclaimerShort": "B. Braun Medical AG makes no warranty or guarantee with regard to the content of the website.",
      "DisclaimerMore": " Under no circumstances shall B. Braun Medical AG, its employees, distributors, suppliers or contractors be liable for damages of any kind, including, but not limited to, incidental, direct, indirect, special, consequential or punitive damages, loss of use, loss of data, loss of revenue or profits, loss or damage to property, claims of third parties or other losses of any kind."
    }
  },
  "News": {
    "Introduction": "In the News section, we inform you about new data on chemical-physical compatibility tests. Furthermore, you will find news about our infusion solutions and pharmaceutical products as well as our rinsing solutions."
  },
  "ProductCatalog": {
    "Title": "Product informations",
    "PresentationSection": {
      "Title": "Product catalog",
      "Resume": "B. Braun offers products and solutions for infusion therapy."
    },
    "Informations": {
      "Title": "Product information",
      "Subtitle1": "Essential product information, such as dosage and use, is available in the professional information on ",
      "Subtitle2": ".",
      "Documentation": "Documentation, information material",
      "Brochures": {
        "Title": "Classification of the various brochures",
        "Products": "Product overview",
        "Concept": "Perfusion concept"
      }
    }
  },
  "ProductDetails": {
    "FAQs": "Product FAQs",
    "Dosage": "Dosage",
    "Documents": "Documentation",
    "Articles": "Articles",
    "Article": {
      "Description": "Description",
      "Reference": "Reference",
      "Pharmacode": "Pharmacode",
      "Quantity": "Quantity",
      "QuantityUnit": "Items"
    }
  },
  "Compatibility": {
    "Title":"Compability data",

    "Drug": "Medicament",
    "DisplayBy": "Display by",
    "DrugSelection": "Drug selection",
    "TestedMixture": "tested mixture",
    "NotTested": "not tested",
    "Compatible": "compatible",
    "Incompatible": "incompatible",
    "IncompatibleShort": "incompatible",

    "Explanation": "The information on the mixing ratio is given here as follows: 1+1 stands for a mixture of 1 part carrier solution plus 1 part drug solution (it runs e.g. 1 mL/minute Ringerfundin together with 1 mL/minute Aequifusin or also 2 mL/minute Ringerfundin together with 2 mL/minute Calcium Braun 10% diluted beforehand 1:11). A dilution 1:11 represents 1 part made up to a total of 11 parts, e.g.: 1 mL Calcium Brown 10% ad 11 mL made up with NaCl 0.9%",

    "ShowAllCompatibilitiesButton":"Show all compabilities",
    "ShowCompatibilitiesButton":"Show compabilities",
    "NoneSelectedError":"Please select at least one product.",
    "From": "from",
    "To": "to",
    "mlperminute": "ml/minute",
    "ml": "ml",

    "Introduction": {
      "Title": "Introduction",
      "IntroductionParagraph1": "The compatibilities listed here refer to physico-chemical compatibility such as pH shift, colour change, turbidity, particle size change or precipitation.",
      "IntroductionParagraph2": "The data do not provide information regarding pharmacokinetics and dynamics. The mixtures listed do not represent dosing recommendations."
    },
    "CarrierSolutions":{
      "Title":"Transport Solution"
    },
    "DrugAddition":{
      "Title":"Drug additive"
    },
    "SelectDrug":{
      "Title":"Choose a drug",

      "TradeNameButton":"Trade name",
      "ActiveIngredientButton":"Active ingredient",

      "AllButton":"All",

      "SelectedMedicinalProducts":"Selected medicinal products"

    },
    "PhysicoChemicalCompatibility":{
      "Title":"Physico-chemical compatibility",
      "Concentration": "Concentration",
      "SolutionConcentration": "Active substance concentration in the medication solution",
      "MedSolution": "Medication solution",
      "MedSolutionConcentration": "Concentration of the medication solution",
      "Volume": "Container's volume",
      "InContainerParagraph": "Physico-chemical compatibility of the solution and medicinal product in container.",
      "InLineParagraph": "Physico-chemical compatibility  of the solution and medicinal product in the line (Y-piece)",

      "CarrierSolution":"Transport Solution",
      "DrugAdditive":"Drug additive",
      "DrugAdditiveTab":{
        "TradeNameAddition":"Trade name",
        "ActiveIngredient":"Active ingredient",
        "MixingRatio":"Effective tested active ingredient concentration in the mixture",
        "TestedIntervals":"Tested infusion rates",
        "TestedMix": "Tested mixture",
        "Compatibility":"Compatibility",
        "Direct":"Direct",
        "DirectDetails":"4 min in contact",
        "Indirect60":"1h in contact",
        "Indirect24":"24h in contact",
        "After":"After",

        "Details":"Details",
        "OpenDetails":"Open details",
        "CloseDetails":"Close details"
      },
      "Results": {
        "MixDetails": "Mix details",
        "Concentration": "Preparation of the medicated solution",
        "QuantityFor500": "Quantity for of transport solution",
        "Comments": "Comments",
        "PossibleResults": "Possible results",
        "TransportSolutionConcentration": "Transport solution concentration",
        "SolutionConcentration": "Solution concentration",
        "DirectCompat": "Direct compatibility",
        "AfterCompat": "Compatibility after 24h"
      },

      "LeitungSlider1": "Infusion speed of carrier solution (ml / min)",
      "LeitungSlider2": "Concentration of the active agent after dilution / reconstitution",
      "LeitungSlider3": "Infusion rate in prepared drug solution (ml / min)",

      "BehaltnisSlider1": "Active agent concentration in the added drug preparation (mg / ml)",
      "BehaltnisSlider2": "Total volume of drug preparation (ml)"

    },
    "CompatibilityRequest":{
      "Title":"Compatibility request",
      "PresentationSection": {
        "Title": "Compatibility request",
        "Resume": "If you frequently use a medication that has not yet been tested, we can perform a compatibility study after consultation. Use the form below to request a study."
      },
      "NewRequest": "Medication not found? Request a new compatibility test!",
      "Editor": "Editor",
      "LabTester": "Labor prüfer",

      "CarrierSolution":"Transport solution",
      "DrugAdditive":"Drug / Additive",
      "DrugAdditiveSubText":"Geben Sie hier Ihren Bedarf an",
      "FirstName":"First name",
      "LastName":"Last name",
      "SpitalInstitution": "Hospital / Institution",
      "Street":"Street",
      "PLZ":"Postal code",
      "Location":"City",
      "Country":"Country",
      "PositionOrFunction":"Position / Function",
      "EmailAddress":"E-mail address",
      "Comment":"Comment",
      "ApplicationDetails": "Application details",
      "EmptyMedsList": "Please add at least one drug / additive",
      "Created": "The request was successfully submitted and will be analyzed by B.Braun in due course.",
      "Wizard": {
        "NewRequest": "New request",
        "Clarification": "Clarification",
        "AcceptPlan": "Accept plan",
        "TestPlan": "Test plan",
        "AcceptResults": "Accept results",
        "Request": "Request",
        "Requester": "Requester",
        "Date": "Date"
      }
    }
  },
  "Osmolarity": {
    "Title": "Osmolarity calculator",
    "Subtitle": "Infusion solutions",
    "Osmolarity": "Osmolarity",
    "Volume": "Volume",
    "Additives": {
      "Title": "Additives"
    },
    "Solutions": {
      "Title": "Infusion solutions"
    },
    "Free": {
      "Title": "Variable input",
      "Name": "Name:",
      "Osmolarity": "Osmolarity:",
      "Volume": "Volume:",
      "Description": "Enter here an osmolarity and a volume."
    },

    "Introduction": {
      "Title": "Introduction",
      "P1": "Calculate the osmolarity of an infusion solution with one or more infusion additives.",
      "P2": "When administering a solution above 900 mosm/l, central venous administration is beneficial to minimize the risk of phlebitis. In pediatrics, consider administering an infusion solution with an osmolarity greater than 500 mosm/l centrally venously.",
      "P3": "With the osmolarity calculator, on the one hand, there is no check of the therapeutic plausibility (no dosage and no application recommendation) and, on the other hand, there is no check of the chemical-physical compatibility of the ingredients."
    },
    "SelectInfusionSolution":{
      "Title":"Select infusion solution"
    },
    "EnterTheInfusionSolutionVolume":{
      "Title":"Enter the infusion solution volume"
    },
    "SelectInfusionAdditives":{
      "Title":"Select infusion additives"
    },
    "EnterVolumeForInfusionAdditives":{
      "Title":"Enter volume for infusion additives"
    },
    "Result":{
      "Title":"Results",
      "InfusionSolution":"Infusion solution",
      "InfusionAdditives":"Infusion additives",
      "TotalVolume":"Total mixture volume (ml)",
      "OsmolarityOfTheMixture":"Mixture osmolarity (mosm/l)",
      "Warning": {
        "below500": "Peripheral and central venous administration possible",
        "between500And800": "Consider central venous administration",
        "above800": "Central venous administration recommended"
      },
      "Ingredients":"Ingredients",
      "Absolutely":"Absolute*",
      "Relative":"Relative**",
      "AbsolutelyDescription":"*Absolute : Details refer to your selected overall solution",
      "RelativeDescription":"**Relative : Details refer to a litre of your selected solution",
      "AdditionalInfo":"For more detailed instructions, refer to the published notice (see notice or www.swissmedicinfo.ch)."
    }
  },
  "SearchPage": {
    "Items": {
      "Any": "items",
      "All": "all",
      "For": "for",
      "Found": "found",
      "Products": "Products only",
      "News": "News only",
      "FAQ": "FAQ only"
    },
    "Types": {
      "product": "Product",
      "news": "New",
      "faq": "FAQ"
    },
    "Research": "Search:",
    "More": "See more"
  },
  "Requester": {
    "RejectionReason": "Rejection reason",
    "Close": "Close",
    "Send": "Send"
  },
  "Privacy": {
    "Title": "Data privacy"
  }
}
